import React, { ReactNode } from 'react';
import css from './index.module.scss';
import { InfoHeaderProps, InfoHeader } from '../InfoHeader';
import { Image } from '../Image';
import Zoom from 'react-medium-image-zoom';

export interface FigureProps extends InfoHeaderProps {
  imgUrl?: string;
  children?: ReactNode;
  half?: boolean;
}

export const Figure = (props: FigureProps) => (
  <figure className={css.container}>
    <InfoHeader
      className={css.content}
      title={props.title}
      description={props.description}
      subtitle={props.subtitle}
    />
    <div className={css.img_container}>
      {props.imgUrl && (
        <Zoom
          wrapStyle={{
            width: '100%',
          }}
        >
          <Image src={props.imgUrl} className={css.img} />
        </Zoom>
      )}
      {props.children}
    </div>
  </figure>
);
